import { useRouterParam } from "../../../hooks/useRouterParam.ts";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const useModelUuid = () => useRouterParam("modelUuid")!;
